//------------ REACT IMPORT --------------//
import React from "react";
//---------- FONTAWESOME IMPORT ----------//
import { faEllipsisVertical } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
//--------- BOOTSTRAP ITEMS IMPORT ----------//
import { Col, Dropdown, Image, Row } from "react-bootstrap";
//------------ IMAGES IMPORT ---------------//
import {
    Card1,
    Delete_2,
    Edit_2,
    Eye_2,
    Group,
    MytaskImg,
    User1,
    User2,
} from "../../../../assets/images";
import { dateFormat, timeFormat } from "../../../Helper/General";
import PaginationComponent from "../../CommanComponents/Pagination";

const Task = (props) => {
    const {
        patientTasks,
        navigate,
        page,
        handlePage,
        handleBackClick,
        handleNextClick,
        totalPages,
    } = props;

    const taskCompletedByAdmin = (item) => {
        if (props.taskCompletedByAdmin) {
            props.taskCompletedByAdmin(item);
        } else return;
    };

    return (
        <>
            <div className="card_section">
                <Row>
                    {patientTasks && patientTasks.length > 0
                        ? patientTasks.map((item, i) => (
                              <Col
                                  xxl={6}
                                  xl={6}
                                  lg={6}
                                  md={6}
                                  sm={6}
                                  xs={12}
                                  key={i}
                              >
                                  <div className="card_area">
                                      {/* //------------ my tasks screen area content ---------------// */}
                                      {/* <div className="mytask_area">
                            <div className="mytask_left_area">
                                <div className="img_area">
                                    <Image src={MytaskImg} alt="..." />
                                </div>
                                <div className="right_name_area">
                                    <p>Willia Jayden</p>
                                    <p><span>MR - 457124</span></p>
                                </div>
                            </div>
                            <div className="mytask_right_area">
                                <p><span>Cardiology</span></p>
                            </div>
                        </div> */}

                                      <div className="sub_title">
                                          <div className="left_area">
                                              <p>
                                                  {dateFormat(item.created)}{" "}
                                                  {timeFormat(item.created)}
                                              </p>
                                          </div>
                                          {parseInt(item.task_status) === 1 ? (
                                              <div className="right_area">
                                                  <p>Complete</p>
                                              </div>
                                          ) : parseInt(item.task_status) ===
                                            0 ? (
                                              <div className="right_area test">
                                                  <p>Pending</p>
                                              </div>
                                          ) : null}
                                      </div>
                                      <div
                                          className={
                                              parseInt(item.task_status) === 1
                                                  ? "card_inner"
                                                  : "card_inner pending"
                                          }
                                      >
                                          <div className="card_inner_detail">
                                              <div className="sub_title">
                                                  {parseInt(item.priority) ===
                                                  1 ? (
                                                      <div className="left_area testt">
                                                          <p>Low</p>
                                                      </div>
                                                  ) : parseInt(
                                                        item.priority
                                                    ) === 2 ? (
                                                      <div className="left_area">
                                                          <p>Medium</p>
                                                      </div>
                                                  ) : parseInt(
                                                        item.priority
                                                    ) === 3 ? (
                                                      <div className="left_area">
                                                          <p>High</p>
                                                      </div>
                                                  ) : null}
                                                  {/* <div className="task_right_area">
                                                    <p>Completed</p>
                                                </div> */}
                                              </div>
                                              <div className="title_area">
                                                  <h5>
                                                      {item.title
                                                          ? item.title
                                                          : ""}
                                                  </h5>
                                              </div>
                                              <div className="description">
                                                  <p>
                                                      {item.description
                                                          ? item.description
                                                          : ""}
                                                  </p>
                                                  {item.start_time &&
                                                  item.end_time ? (
                                                      <p>
                                                          {" "}
                                                          <span>
                                                              {timeFormat(
                                                                  item.start_time
                                                              )}{" "}
                                                              to{" "}
                                                              {timeFormat(
                                                                  item.end_time
                                                              )}
                                                          </span>{" "}
                                                      </p>
                                                  ) : null}
                                              </div>
                                              {item.assigned_members &&
                                              item.assigned_members.length >
                                                  0 ? (
                                                  <div className="group_image">
                                                      <div className="image_area">
                                                          <Image
                                                              src={User1}
                                                              alt="..."
                                                          />
                                                      </div>
                                                      {item.assigned_members
                                                          .length > 1 ? (
                                                          <div className="image_area img_2">
                                                              <Image
                                                                  src={User2}
                                                                  alt="..."
                                                              />
                                                          </div>
                                                      ) : null}
                                                      {item.assigned_members
                                                          .length === 3 ? (
                                                          <div className="image_area img_2">
                                                              <Image
                                                                  src={User2}
                                                                  alt="..."
                                                              />
                                                          </div>
                                                      ) : item.assigned_members
                                                            .length > 3 ? (
                                                          <a>
                                                              <div className="image_area img_3">
                                                                  <p>3+</p>
                                                              </div>
                                                          </a>
                                                      ) : null}
                                                  </div>
                                              ) : null}
                                          </div>
                                          <div className="bottom_area">
                                              <div className="inner_area">
                                                  <div className="left_area">
                                                      <div className="img_area">
                                                          <Image
                                                              variant="left"
                                                              src={Card1}
                                                              alt="..."
                                                          />
                                                      </div>
                                                  </div>
                                                  <div className="right_area">
                                                      <div className="name_area">
                                                          <h3>
                                                              {item.assign_by
                                                                  ? item.assign_by
                                                                  : ""}
                                                          </h3>
                                                          <p>
                                                              {item.specialization
                                                                  ? item.specialization
                                                                  : ""}
                                                          </p>
                                                          <Dropdown>
                                                              <Dropdown.Toggle
                                                                  variant="none"
                                                                  id="dropdown-basic"
                                                              >
                                                                  <FontAwesomeIcon
                                                                      icon={
                                                                          faEllipsisVertical
                                                                      }
                                                                      className="ellipsis_icon"
                                                                  />
                                                              </Dropdown.Toggle>
                                                              {parseInt(
                                                                  item.task_status
                                                              ) === 1 ? (
                                                                  <Dropdown.Menu>
                                                                      <Dropdown.Item
                                                                          onClick={() =>
                                                                              navigate(
                                                                                  "/myTaskDetails",
                                                                                  {
                                                                                      state: {
                                                                                          id: item.id,
                                                                                      },
                                                                                  }
                                                                              )
                                                                          }
                                                                      >
                                                                          View
                                                                      </Dropdown.Item>
                                                                  </Dropdown.Menu>
                                                              ) : (
                                                                  <Dropdown.Menu>
                                                                      <Dropdown.Item
                                                                          onClick={() =>
                                                                              taskCompletedByAdmin(
                                                                                  item
                                                                              )
                                                                          }
                                                                      >
                                                                          Completed
                                                                      </Dropdown.Item>
                                                                  </Dropdown.Menu>
                                                              )}
                                                          </Dropdown>
                                                      </div>
                                                  </div>
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                              </Col>
                          ))
                        : null}
                    {/* <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={12}>
                    <div className="card_area">
                        <div className="mytask_area">
                            <div className="mytask_left_area">
                                <div className="img_area">
                                    <Image src={MytaskImg} alt="..." />
                                </div>
                                <div className="right_name_area">
                                    <p>Willia Jayden</p>
                                    <p><span>MR - 457124</span></p>
                                </div>
                            </div>
                            <div className="mytask_right_area">
                                <p><span>Cardiology</span></p>
                            </div>
                        </div>
                        <div className="sub_title">
                            <div className="left_area">
                                <p>11 june 2023  11:00AM</p>
                            </div>
                            <div className="right_area test">
                                <p>Pending</p>
                            </div>
                        </div>
                        <div className="card_inner pending">
                            <div className="card_inner_detail">
                                <div className="sub_title">
                                    <div className="left_area testt">
                                        <p>Low</p>
                                    </div>
                                    <div className="task_right_area pending">
                                        <p>Pending</p>
                                    </div>
                                </div>
                                <div className="title_area">
                                    <h5> Diagnosing and Treating</h5>
                                </div>
                                <div className="description">
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing
                                        elit. Etiam sem orc </p>
                                    <p> <span>10:30 AM to 11:00 AM</span> </p>
                                </div>
                                <div className="group_image">
                                    <div className="image_area">
                                        <Image src={User1} alt="..." />
                                    </div>
                                    <div className="image_area img_2">
                                        <Image src={User2} alt="..." />
                                    </div>
                                    <a href="javascript:;">
                                        <div className="image_area img_3">
                                            <p>3+</p>
                                        </div>
                                    </a>

                                </div>
                            </div>
                            <div className="bottom_area">
                                <div className="inner_area">
                                    <div className="left_area">
                                        <div className="img_area">
                                            <Image variant="left" src={Card1} alt="..." />
                                        </div>
                                    </div>
                                    <div className="right_area">
                                        <div className="name_area">
                                            <h3>Robert William</h3>
                                            <p>Consultant</p>
                                            <Dropdown>
                                                <Dropdown.Toggle variant="none" id="dropdown-basic">
                                                    <FontAwesomeIcon icon={faEllipsisVertical} className="ellipsis_icon" />
                                                </Dropdown.Toggle>

                                                <Dropdown.Menu>
                                                    <Dropdown.Item href="javascript:;">
                                                        Completed
                                                    </Dropdown.Item>
                                                    <Dropdown.Item href="javascript:;">
                                                        Pending
                                                    </Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Col> */}
                </Row>
            </div>

            {patientTasks && patientTasks.length > 0 ? (
                <PaginationComponent
                    page={page}
                    setPage={handlePage}
                    totalPages={totalPages}
                    handleBackClick={handleBackClick}
                    handleNextClick={handleNextClick}
                />
            ) : null}
        </>
    );
};

export default Task;
